export default __webpack_public_path__ + "static/media/agent-strategy.png";